import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Layout } from '../components/layout';
import { Button } from '../components/common';
import { useAuth } from '../hooks/useAuth';

export const Landing = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // Redirect authenticated users to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="py-20 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            FATE AFTER DICE
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Asynchronous Collaborative Storytelling
          </p>
          <p className="text-lg text-gray-500 mb-12 max-w-3xl mx-auto">
            Create epic stories with friends across time zones.
            No scheduling conflicts. No pressure. Just creativity.
          </p>

          <div className="flex justify-center gap-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 max-w-xs">
              <h3 className="text-lg font-semibold mb-2">Create Game</h3>
              <p className="text-gray-600 mb-4 text-sm">
                Start a new story as GM
              </p>
              <Button onClick={() => navigate('/register')}>
                Get Started
              </Button>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 max-w-xs">
              <h3 className="text-lg font-semibold mb-2">Join a Game</h3>
              <p className="text-gray-600 mb-4 text-sm">
                Have an invite code? Jump in!
              </p>
              <Button variant="secondary" onClick={() => navigate('/login')}>
                Enter Code
              </Button>
            </div>
          </div>
        </div>

        {/* How It Works */}
        <div className="py-16 border-t border-gray-200">
          <h2 className="text-2xl font-bold text-center mb-12">How It Works</h2>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-primary-600 font-bold">1</span>
              </div>
              <h3 className="font-semibold mb-2">GM Sets the Scene</h3>
              <p className="text-gray-600 text-sm">
                The Game Master writes a prompt to set up the situation
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-primary-600 font-bold">2</span>
              </div>
              <h3 className="font-semibold mb-2">Players Submit Content</h3>
              <p className="text-gray-600 text-sm">
                Players contribute prose, images, or audio to the story
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-primary-600 font-bold">3</span>
              </div>
              <h3 className="font-semibold mb-2">GM Weaves the Story</h3>
              <p className="text-gray-600 text-sm">
                The GM combines everything into the next chapter
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
